<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="version-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-bookmark"></i>
                        <span v-if="version.id">現在の版を編集</span>
                        <span v-else>現在の版を新規保存</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>版のコメント</label>
                        <input type="text" v-model="version.version_name"
                            class="form-control"
                            placeholder="15文字以内でコメント"
                            @keydown.enter="save($event)"
                            id="version-name">
                        <div class="small mt-2 font-weight-bold" v-if="version.id">
                            {{$filters.dateFormat(version.updated_at)}} の版
                        </div>
                        <div class="small mt-2">
                            版にコメントをつけると、後で探しやすくなります。<br>
                            直近の版から変更が無い場合、版は保存されません。
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: null,
        },
        section_id: {
            required: true,
        },
    },
    data() {
        return {
            version: {}
        }
    },
    methods: {
        load() {
            if (!this.id) return;
            axios.get("/mypage/book/version/get", {params: {id: this.id}}).then(res => {
                this.version = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save(ev = null) {
            if (ev && ev.isComposing) return;
            this.version.section_id = this.section_id;
            axios.post("/mypage/book/version/save", this.version).then(res => {
                alert.msg(res.data);
                $("#version-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        }
    },
    mounted() {
        $("#version-modal").on("show.bs.modal", (e) => {
            this.version = {};
            this.load();
            setTimeout(() => {
                $("#version-name").focus();
            }, 500);
        });
    }
}
</script>